import styled, { withTheme } from 'styled-components';
import { Label as bootstrapLabel } from '@bootstrap-styled/v4';

const Label = styled(bootstrapLabel)`
    font-size: ${props => props.theme['$font-size-16']};
    color:${props => props.theme.$dark};
    font-style: normal;
    font-family: ${props => props.theme['$font-family-sans-serif-regular']};
`;

export default withTheme(Label);
